import { useEffect, useRef } from "react";
import { useRouterState } from "@tanstack/react-router";

import { scrollToHashWhenReady } from "@/lib/smooth-scroll";

/** Smoothly scrolls to the location hash on every navigation, so hash links
 *  behave identically whether you're already on the page or arriving from
 *  another route. */
export function useSmoothHashScroll() {
  const hash = useRouterState({ select: (s) => s.location.hash });
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const last = useRef<string | null>(null);

  useEffect(() => {
    const key = `${pathname}#${hash}`;
    if (!hash) {
      last.current = key;
      return;
    }
    if (last.current === key) return;
    last.current = key;
    scrollToHashWhenReady(hash);
  }, [hash, pathname]);
}
